import axios from "axios";
import { useEffect, useState } from "react";
import { TokenName, TokenTime } from "../util/Common";
import { API_URL } from "../api/apiConfig";
import { setCookie } from "../util/Cookie";
import { useHistory } from "react-router-dom";
import { ApiProducts } from "../api/apiKey/ApiProducts";
import { ApiList } from "../api/apiKey/ApiList";
import { useSetRecoilState } from "recoil";
import { apiProductsState } from "../atom/Products";
import { apiKeyState } from "../atom/ApiKey";

const KakaoRedirectURL = () => {
  const history = useHistory();

  useEffect(() => {
    const fetchAuthData = async () => {
      try {
        const code = new URL(window.location.href).searchParams.get("code");
        const state = new URL(window.location.href).searchParams.get("state");
        const resp = await axios.post(
          `${API_URL}/api/auth/kakao/login?code=${code}&state=${state}`
        );
        const tokenData = resp.data;

        if (resp.status == 200) {
          setCookie(TokenName, tokenData.access_token, {
            path: "/",
            maxAge: TokenTime,
          });

          history.push("/")
        } else {
          return;
        }
      } catch (error) {
        console.error("error", error);
        alert("죄송합니다. 잠시 후 다시 시도해주세요.")
        history.push("/login")
        // navigate(`/login`);
      }
    };
    fetchAuthData();
  }, []);
  return <div></div>;
};

export default KakaoRedirectURL;
